import $ from 'jquery';
import i18n, { t }  from '../i18n/i18n.js';
import MessagePopupView from '../../controls/MessagePopupView.js';
import LoadingPopupView from '../../controls/LoadingPopupView.js';
import PopupBase from './PopupBase.js';
import app from '../App.js';
import ContactReassignOptionsPopup from './ContactReassignOptionsPopup.js';

var template =
    '<table class="edit-table">' +
    '  <tbody>' +
    '    <tr>' +
    '      <td><input type="radio" name="export_campaign_mode" value="new" id="export_campaign_mode_new" checked="checked" /></td>' +
    '      <td><label for="export_campaign_mode_new">{export_to_campaign_popup.new}</label></td>' +
    '    </tr>' +
    '    <tr>' +
    '      <td></td>' +
    '      <td><input type="text" name="export_campaign_new_name" placeholder="{export_to_campaign_popup.campaign_name_placeholder}" /></td>' +
    '    </tr>' +
    '    <tr>' +
    '      <td><input type="radio" name="export_campaign_mode" value="existing" id="export_campaign_mode_existing" /></td>' +
    '      <td><label for="export_campaign_mode_existing">{export_to_campaign_popup.existing}</label></td>' +
    '    </tr>' +
    '    <tr>' +
    '      <td></td>' +
    '      <td><select name="export_campaign_existing_options"></select></td>' +
    '    </tr>' +
    '  </tbody>' +
    '</table>' +
    '<div class="popup-actions">' +
    '  <button class="cancel-button">{cancel}</button>' +
    '  <button class="save-button">{save}</button>' +
    '</div>';

/** @class ExportToCampaignPopup */
var ExportToCampaignPopup = PopupBase.extend(
    /** @lends ExportToCampaignPopup.prototype */
    {

        className: 'popup-frame medium-size export-to-campaign-popup',
        hasAutoReposition: false,
        hasContentArea: false,

        /** @constructs */
        initialize: function (options) {

            ExportToCampaignPopup.__super__.initialize.apply(this, arguments);

            var that = this;

            that.$el.append(i18n.processLocalizedString(template));

            that.listenTo(that, 'show', that.onShow);
            that.listenTo(that, 'hide', that.onHide);

            that.$el.find('select[name=export_campaign_existing_options]').on('change', function () {
                that.$el.find('input[name=export_campaign_mode][value=existing]').prop('checked', true);
            });
            that.$el.find('input[name=export_campaign_new_name]').on('change', function () {
                that.$el.find('input[name=export_campaign_mode][value=new]').prop('checked', true);
            });

            that.$el.find('.cancel-button').click(that.onCancel.bind(that));
            that.$el.find('.save-button').click(that.onSave.bind(that));
        },

        onShow: function () {
            var that = this;

            that._loader = new LoadingPopupView(t('activity_indicator.loading'));

            that.ajaxGet(app.apiUrl('campaigns', {
                'project_id': that.options.projectId,
                'fields': 'id,name'
            }))
                .then(function (rows) {

                    var $select = that.$el.find('select[name=export_campaign_existing_options]');
                    rows.forEach(function (item) {
                        $('<option>').val(item['id']).text(item['name']).appendTo($select);
                    });

                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                    app.setData(false);
                });
        },

        onHide: function () {
            var that = this;

            if (that._loader) {
                that._loader.hide();
            }
        },

        onCancel: function () {
            return this.trigger('cancel').hide();
        },

        onSave: function () {
            var that = this;

            that.$el.find('input,textarea,select').removeClass('invalid');

            var mode = that.$el.find('input[name=export_campaign_mode]:checked').val();
            var campaignId, campaignName;

            if (mode === 'existing') {
                campaignId = that.$el.find('select[name=export_campaign_existing_options]').val();
            }

            campaignName = that.$el.find('input[name=export_campaign_new_name]').val().trim();

            if (mode === 'existing' && !campaignId) {
                that.$el.find('select[name=export_campaign_existing_options]').addClass('invalid');
                return that;
            }

            if (mode === 'new' && !campaignName) {
                that.$el.find('input[name=export_campaign_new_name]').addClass('invalid');
                return that;
            }

            that.assignContacts(campaignId, campaignName, that.options.contactIds);

            return that;
        },

        /**
         *
         * @param {int?} campaignId - existing campaign id
         * @param {String?} campaignName - campaign name
         * @param {Array<int>} contactIds - array of contact ids
         * @param {String?} conflictResolveMode - conflict resolving mode
         * @param {int?} endReasonId - end_reason_id for conflict=='end_reason'
         * @returns {ExportToCampaignPopup}
         */
        assignContacts: function (campaignId, campaignName, contactIds, conflictResolveMode, endReasonId) {
            var that = this;

            var data = {};

            if (!campaignId) {
                data['name'] = campaignName;
            }

            data['project_id'] = that.options.projectId;
            data['assign_contacts'] = {
                'ids': contactIds
            };

            if (conflictResolveMode) {
                data['assign_contacts']['conflict'] = conflictResolveMode;
            }

            if (endReasonId) {
                data['assign_contacts']['end_reason_id'] = endReasonId;
            }

            if (!campaignId) {
                data['mode'] = 'outgoing';
                data['status'] = 'inactive';
            }

            var apiUrl;
            if (campaignId) {
                apiUrl = app.apiUrl('campaigns/' + encodeURIComponent(campaignId));
            } else {
                apiUrl = app.apiUrl('campaigns');
            }

            app.AlertUI.showLoader(t('activity_indicator.saving'));

            that.ajaxJsonPost(apiUrl, data)
                .always(function () {
                    app.AlertUI.hideLoader();
                })
                .then(function (response) {
                    that._saveNeeded = false;

                    campaignId = response['id'];

                    if (response['conflict']) {
                        // We have a conflict
                        that.handleConflict(response['conflict'], campaignId, campaignName);
                    } else {

                        new MessagePopupView({
                            addClass: 'done',
                            message: t('export_to_campaign_popup.saved_prompt'),
                            queue: true
                        }).show();
                        that.trigger('complete').hide();
                    }
                })
                .fail(function (xhr, error) {
                    app.showXhrError(xhr, error);
                });

            return that;
        },

        handleConflict: function (conflict, campaignId, campaignName) {
            var that = this;

            var popup = new ContactReassignOptionsPopup({
                'projectId': that.options.projectId,
                'campaign_id': campaignId,
                'campaign_name': campaignName,
                'count': conflict.length,
                'contacts': conflict
            });

            that.listenTo(popup, 'save', function (event) {
                that.assignContacts(campaignId, campaignName, conflict.map(x => x.contact_id), event.mode, event.endReasonId);
            }).listenTo(popup, 'cancel', function () {

                new MessagePopupView({
                    addClass: 'done',
                    message: t('export_to_campaign_popup.saved_prompt'),
                    queue: true
                }).show();
                that.trigger('complete').hide();
            });

            popup.show();

            return that;
        },

        remove: function () {
            var that = this;

            if (that._loader) {
                that._loader.remove();
            }

            ExportToCampaignPopup.__super__.remove.apply(this, arguments);
        }

    }
);

export default ExportToCampaignPopup;
